import { render, staticRenderFns } from "./resourceData.vue?vue&type=template&id=4611a929&scoped=true"
import script from "./resourceData.vue?vue&type=script&lang=js"
export * from "./resourceData.vue?vue&type=script&lang=js"
import style0 from "./resourceData.vue?vue&type=style&index=0&id=4611a929&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_css-loader@6.8.1_vue-template-compiler@2.7.15_webpack@5.89.0/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4611a929",
  null
  
)

export default component.exports